<template>
  <div class="modal sign-modal page-inside">
    <div class="main-wrapper">
      <section class="section hero-section">
        <div class="wrapper">
          <div class="container">
            <div class="form">
              <div class="form-wrapper">
                <div class="form-fields login-content">
                  <div class="tabs">
                    <div class="title title-18">
                      <b>Login</b>
                    </div>
                    <div class="title title-18 gray" @click="$parent.openSignUp">
                      <b>Sign Up</b>
                    </div>
                  </div>
                  <div class="form-fields-wrapper">
                    <label>
                      <div class="desc">E-mail:</div>
                      <input type="email" placeholder="Email" v-model="email"/>
                    </label>
                    <label>
                      <div class="desc">Password:</div>
                      <input type="password" placeholder="Password" v-model="pass"/>
                    </label>
                    <div class="cta-container">
                      <button class="button" @click="submitLogin">
                        <span>Log In</span>
                      </button>
                      <div class="link" @click="switchToforgotPass">Forgot password?</div>
                    </div>
                    <transition name="slide">
                      <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                    </transition>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Login',
  props: [],
  components: {
  },
  data: function() {
    return {
      email: '',
      pass: ''
    }
  },
  mounted() {
    
  },
  methods: {
    switchToforgotPass() {
      this.$parent.clearError();
      this.$parent.openRecover();
    },
    switchToLogin() {
      this.$parent.clearError();
      this.$parent.openSignIn();
    },
    submitLogin() {
      let loginData = {
        "username": this.email,
        "password": this.pass
      }
      this.$emit('login', loginData)
    }
  }
}
</script>